import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const DeleteFavourite = {
  name: 'deleteFavourite',
  state: {
    loading: false,
    error: '',
    success: '',
  },
  reducers: {
    deleteRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        success: '',
      };
    },
    deleteSucceeded(state) {
      return {
        ...state,
        loading: false,
        error: '',
        success: 'Advertiser removed from favourites successfully.',
      };
    },

    deleteFailed(state, payload) {
      return {
        ...state,
        error: payload,
        loading: false,
        success: '',
      };
    },

    clearMessages(state) {
      return {
        ...state,
        error: '',
        success: '',
      };
    },
  },
  effects: (dispatch) => ({
    async removeFavourite({ org_id }) {
      try {
        this.deleteRequested();

        await http.delete(`savvy/favourite/${org_id}`);
        this.deleteSucceeded();

        dispatch({
          type: 'helper/show',
          payload: {
            type: 'success',
            message: 'Advertiser removed from favourites successfully.',
            show: true,
          },
        });
      } catch (error) {
        const errorMessage = responseMessageHandler.show(error.message);
        this.deleteFailed(errorMessage);

        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: errorMessage,
            show: true,
          },
        });
      }
    },

    async clearStateMessages() {
      this.clearMessages();
    },
  }),
};

export default DeleteFavourite;
